import './scss/Mirt.scss';
export { default } from './Mirt';
